import Layout from '@/layout/index.vue'

export const ContractsRoute = {
  path: '/contracts',
  component: Layout,
  redirect: '/contracts',
  children: [
    {
      path: '',
      component: (): Promise<any> =>
        import(/* webpackChunkName: "contracts" */ '@/features/contracts/views/index.vue'),
      name: 'ContractsRoute',
      meta: {
        title: 'ContractsRouteTitle',
        requiresAuth: true
      }
    },
    {
      path: 'create/:partnerId?',
      component: (): Promise<any> =>
        import(/* webpackChunkName: "contracts-create" */ '@/features/contracts/views/create-update-contract.vue'),
      name: 'ContractsCreateRoute',
      meta: {
        title: 'ContractsCreateRouteTitle',
        requiresAuth: true,
        action: 'create'
      }
    },
    {
      path: 'update/:contractId',
      component: (): Promise<any> =>
        import(/* webpackChunkName: "contracts-update" */ '@/features/contracts/views/create-update-contract.vue'),
      name: 'ContractsUpdateRoute',
      meta: {
        title: 'ContractsUpdateRouteTitle',
        requiresAuth: true,
        action: 'update'
      }
    },
    {
      path: 'view/:contractId',
      component: (): Promise<any> =>
        import(/* webpackChunkName: "contracts-details" */ '@/features/contracts/views/details.vue'),
      name: 'ContractDetailsRoute',
      meta: {
        title: 'ContractDetailsRouteTitle',
        requiresAuth: true
      }
    }
  ]
}
